import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = {
  key: 0,
  class: "page-title"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PageHeaderProject',
  props: {
    title: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(__props.title), 1))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})